export class Equipment {
  public equipmentId: string;
  public equipmentDetailId: string;
  public customerName: string;
  public customerShortName: string;
  public location: string;
  public locationShort: string;
  public jobIds: Array<number>;
  public jobNumbers: Array<string>;
  public endUser: string;
  public prodCategory: string;
  public brand: string;
  public formodel: string;
  public designationNumber: string;
  public serialNumber: string;
  public model: string;
  public contractStartDate: Date;
  public contractEndDate: Date;
  public productName: string;
  public description: string;
  public type: string;
  public ratingOrCapacity: string;
  public remarks: string;
  public prodCategoryId: number;
  public siteId: number;
  public isActive: string;
  public migratedFrom: string;
  public migratedTo: string;

  constructor (
    equipmentId = '',
    equipmentDetailId = '',
    customerName = '',
    customerShortName = '',
    location = '',
    locationShort = '',
    jobIds = [],
    jobNumbers = [],
    endUser = '',
    prodCategory = '',
    brand = '',
    formodel = '',
    designationNumber = '',
    serialNumber = '',
    model = '',
    contractStartDate = null,
    contractEndDate = null,
    productName = '',
    description = '',
    type = '',
    ratingOrCapacity = '',
    remarks = '',
    prodCategoryId = 0,
    siteId = 0,
    isActive = '',
    migratedFrom = '',
    migratedTo = ''
  ) {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/equipment.ts